import toast from 'react-hot-toast'
import getErrorMessage from '@src/utility/alerts/getErrorMessage'
import { ERROR_TOAST_MESSAGES, ERROR_TOAST_MODULES } from './errorToastModules'

const DEFAULT_MESSAGE = 'No se pudo cargar la información.'

//'appUsers/getUsers/rejected' -> { module: 'appUsers', operation: 'getUsers' }
const parseActionType = (type = '') => {
    const segments = type.split('/')

    return {
        module: segments[0] ?? '',
        operation: segments.length > 2 ? segments[segments.length - 2] : ''
    }
}

/**
 * Indica si el middleware ya mostró (o mostrará) el toast de esta acción.
 *
 * Exportada para las pantallas que resuelven su propio toast de carga con el
 * resultado de varios thunks: así sólo avisan de los fallos que nadie más notifica.
 */
export const shouldNotify = (action) => {
    if (!action?.type?.endsWith('/rejected')) return false
    //Un thunk cortado por su `condition` (caché) no es un error real
    if (action.meta?.condition || action.meta?.aborted) return false

    const { module, operation } = parseActionType(action.type)

    //Sólo lecturas: una escritura fallida necesita reaccionar en el componente
    return ERROR_TOAST_MODULES.includes(module) && operation.startsWith('get')
}

/**
 * Muestra un único toast por operación fallida de lectura.
 *
 * El id del toast es el action type sin el sufijo de estado, así que si la misma
 * petición truena desde varias pantallas a la vez se actualiza un solo toast en
 * lugar de apilar uno por componente.
 */
export const errorToastMiddleware = () => next => action => {
    const result = next(action)

    if (shouldNotify(action)) {
        const operationType = action.type.slice(0, action.type.lastIndexOf('/'))

        toast.error(getErrorMessage(action, ERROR_TOAST_MESSAGES[operationType] ?? DEFAULT_MESSAGE), { id: operationType })
    }

    return result
}

export default errorToastMiddleware
